import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import Icon from '../../../components/AppIcon';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-card border border-border rounded-lg p-3 shadow-elevation-2">
        <p className="text-sm font-medium text-foreground mb-2">{label}</p>
        {payload.map((entry, index) => (
          <p key={index} className="text-xs" style={{ color: entry.color }}>
            {`${entry.name}: ${entry.value}`}
          </p>
        ))}
      </div>
    );
  }
  return null;
};

const SurveyVolumeChart = ({ data = [], className = '' }) => {
  const current = data[data.length - 1] || {};
  const totalSurveys = data.reduce((sum, d) => sum + (d.surveys || 0), 0);
  const avgSurveys = data.length ? Math.round(totalSurveys / data.length) : 0;

  return (
    <div className={`bg-card rounded-lg border border-border p-6 ${className}`}>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-2">
          <Icon name="TrendingUp" size={20} color="var(--color-primary)" />
          <h3 className="text-lg font-semibold text-foreground">Survey Volume Trends</h3>
        </div>
        <div className="flex items-center space-x-4 text-xs text-muted-foreground">
          <div className="flex items-center space-x-1">
            <div className="w-3 h-3 bg-primary rounded-full" />
            <span>Surveys</span>
          </div>
        </div>
      </div>

      <div className="w-full h-80">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis dataKey="month" stroke="var(--color-muted-foreground)" fontSize={12} />
            <YAxis stroke="var(--color-muted-foreground)" fontSize={12} />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            <Line
              type="monotone"
              dataKey="surveys"
              stroke="var(--color-primary)"
              strokeWidth={3}
              dot={{ fill: 'var(--color-primary)', strokeWidth: 2, r: 4 }}
              name="Surveys"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="mt-4 grid grid-cols-3 gap-4 text-center">
        <div className="p-3 bg-muted rounded-md">
          <p className="text-lg font-bold text-primary">{current.surveys ?? 0}</p>
          <p className="text-xs text-muted-foreground">Current Month</p>
        </div>
        <div className="p-3 bg-muted rounded-md">
          <p className="text-lg font-bold text-success">{totalSurveys}</p>
          <p className="text-xs text-muted-foreground">Total (8 Months)</p>
        </div>
        <div className="p-3 bg-muted rounded-md">
          <p className="text-lg font-bold text-warning">{avgSurveys}</p>
          <p className="text-xs text-muted-foreground">Monthly Average</p>
        </div>
      </div>
    </div>
  );
};

export default SurveyVolumeChart;
